import buildAnalyticsClient from './create-client';
import { getAnalyticsBuildConfig, getAnalyticsIdentity } from './config';

let client = null;

export function getAnalytics() {
    if (!client) {
        client = buildAnalyticsClient(getAnalyticsBuildConfig());
        client.setCommonProps(getAnalyticsIdentity());
        client.identify();
    }

    return client;
}

export function trackEvent(name, props = {}) {
    try {
        const result = getAnalytics().track(name, props);

        if (result && typeof result.catch === 'function') {
            result.catch(() => {});
        }
    } catch (error) { // eslint-disable-line no-unused-vars
        // Analytics should never interrupt a teacher's flow.
    }
}

export { ANALYTICS_EVENTS } from './events';
